export default "__VITE_ASSET__DR_TL7IL__"